import axiosInstance from "../axios-instance";
import { ValidatePaymentRequest } from "../models/request/validate-payment-request";
import {APP_API_URL} from "../constants";

const postUser = (payload: any) => {
    return axiosInstance.post(`https://www.codex47.com/payment`, payload);
}

const postPaymentValidation = (payload: ValidatePaymentRequest) => {
    return axiosInstance.post(`${APP_API_URL}/payment/api/v1/payments/validate-payment-token`, payload);
}

const getPaymentRequests = (page: number, limit: number, status: string) => {
    return axiosInstance.get(`${APP_API_URL}/payment/api/v1/admin/payment-requests?page=${page}&limit=${limit}&status=${status}`);
}

const getPaymentsList = (page: number, limit: number, status: string) => {
    return axiosInstance.get(`${APP_API_URL}/payment/api/v1/admin/payments?page=${page}&limit=${limit}&status=${status}`);
}


const getPaymentStatus = (paymentRequestId: String) => {
    return axiosInstance.get(`${APP_API_URL}/payment/api/v1/payments/payment-status/${paymentRequestId}`);
}

export {
    postUser,
    postPaymentValidation,
    getPaymentRequests,
    getPaymentsList,
    getPaymentStatus,
}